import { Language } from '../enums';
import { LanguageValue } from '../models/LanguageValue';

export const DEFAULT_LANGUAGE_VALUE: LanguageValue = {
    en: '',
    de: '',
    es: '',
    fr: '',
    it: '',
    pt: '',
    cn: '',
    tr: '',
    nl: '',
    pl: '',
    cs: ''
};

export const LANGUAGES: { key: Language, code: string }[] = [
    { key: 0, code: 'en' },
    { key: 1, code: 'de' },
    { key: 2, code: 'es' },
    { key: 3, code: 'fr' },
    { key: 4, code: 'it' },
    { key: 5, code: 'pt' },
    { key: 6, code: 'cn' },
    { key: 7, code: 'tr' },
    { key: 8, code: 'nl' },
    { key: 9, code: 'pl' },
    { key: 10, code: 'cs' }
];
